import React from 'react';
import { Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { CLAIM_GROUP_SHOW_ALL_PROJECT } from '@rd-web-markets/market/dist/constants';
const ClaimGroupsListNavigationDefault = _ref => {
  let {
    page
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(state => state.auth.user);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    variant: "tabs"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'claim_groups',
    to: `/${user.account_type}/all_claim_groups/`
  }, t('claim_groups'))), !['/de', '/it'].includes(process.env.PUBLIC_URL) && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'claims',
    to: `/${user.account_type}/all_claims/`
  }, t('claims'))), CLAIM_GROUP_SHOW_ALL_PROJECT && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'projects',
    to: `/${user.account_type}/projects/all`
  }, t('project_list')))));
};
export default ClaimGroupsListNavigationDefault;